<script setup lang="ts">
import type { BagAllowance } from '@optionway/models';

const properties = defineProps<{ bagAllowances: BagAllowance[]; loading?: boolean }>();

const prefix = 'components.results.bagAllowances';
</script>

<template>
  <div class="inline-flex h-8 items-center justify-start gap-3">
    <!-- Smaller resolutions: bottom sheet -->
    <UiCustomBottomSheet
      :title="$t(`${prefix}.title`)"
      :close-label="$t(`${prefix}.close`)"
      trigger-class="md:hidden"
      content-class="gap-5"
    >
      <template #trigger>
        <ResultsBagAllowancesIcons
          :loading="properties.loading"
          :bag-allowances="properties.bagAllowances"
        />
      </template>
      <ResultsBagAllowancesDetails
        :loading="properties.loading"
        :bag-allowances="properties.bagAllowances"
      />
    </UiCustomBottomSheet>

    <!-- Larger resolutions: tooltip -->
    <UiTooltip>
      <UiTooltipTrigger
        as-child
        class="hidden md:inline-flex"
        :aria-label="$t(`${prefix}.title`)"
      >
        <ResultsBagAllowancesIcons
          :loading="properties.loading"
          :bag-allowances="properties.bagAllowances"
        />
      </UiTooltipTrigger>
      <UiTooltipContent>
        <div class="min-w-72 py-2">
          <div class="pb-3 text-base font-semibold">
            {{ $t(`${prefix}.title`) }}
          </div>
          <ResultsBagAllowancesDetails
            :loading="properties.loading"
            :bag-allowances="properties.bagAllowances"
          />
        </div>
      </UiTooltipContent>
    </UiTooltip>
  </div>
</template>
